// extracted by mini-css-extract-plugin
export var fixed = "styles-module--fixed--841ab";
export var layout = "styles-module--layout--0e5a5";
export var left = "styles-module--left--eeaee";
export var reverse = "styles-module--reverse--8c5a4";
export var right = "styles-module--right--5789e";